import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { TelegramService } from '../telegram/telegram.service';

export abstract class BaseApiService {
  protected http = inject(HttpClient);
  protected telegramService = inject(TelegramService);
}
